/* Reemplazo de los whileInView de framer-motion: añade .is-revealed una sola vez.
   data-reveal="up|fade|scale|stagger"; en stagger, los [data-reveal-item] entran con 0.06 s de desfase.
   Con reduced-motion todo queda revelado de inmediato (estado final visible). */
(() => {
  const els = document.querySelectorAll('[data-reveal]');
  const reveal = (el) => el.classList.add('is-revealed');
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(reveal);
    return;
  }
  document.querySelectorAll('[data-reveal="stagger"]').forEach((group) => {
    group.querySelectorAll('[data-reveal-item]').forEach((item, i) => { item.style.transitionDelay = `${i * 0.06}s`; });
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -80px 0px' });
  els.forEach((el) => io.observe(el));
})();

/* Fundido de fotos (.img-fade): marca data-loaded al cargar (o al fallar, para no dejarla invisible).
   Escucha en captura porque 'load' de <img> no burbujea; cubre también las que ya estaban en caché. */
(() => {
  const mark = (img) => { img.dataset.loaded = '1'; };
  const done = (e) => { if (e.target instanceof HTMLImageElement && e.target.classList.contains('img-fade')) mark(e.target); };
  document.addEventListener('load', done, true);
  document.addEventListener('error', done, true);
  document.querySelectorAll('img.img-fade').forEach((img) => { if (img.complete) mark(img); });
})();
